import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useTranslation } from '@/hooks/use-translation'
import type { SelectFilterProps } from '../../types/data-table.types'

export function SelectFilter({
  columnId,
  columnTitle,
  value,
  onChange,
  options,
  placeholder,
}: SelectFilterProps) {
  const t = useTranslation()

  return (
    <div className="space-y-1">
      <label htmlFor={`filter-select-${columnId}`} className="text-xs font-medium">
        {columnTitle}
      </label>
      <Select
        value={value || 'all'}
        onValueChange={(val) => onChange(val === 'all' ? undefined : val)}
      >
        <SelectTrigger id={`filter-select-${columnId}`} className="w-full h-7 text-xs">
          <SelectValue placeholder={placeholder || t('dataTable.selectStatus')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" className="text-xs">
            {t('dataTable.all')}
          </SelectItem>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value} className="text-xs">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
